import React, { useState } from "react"
import withRouter from "../../../Common/withRouter"
import PropTypes from "prop-types"

const MenuBar = props => {
  return (
    <React.Fragment>
      <div className="billing-details-menu">
        {props.menuList.map((menu, index) => (
          <span
            key={menu?.id}
            className={`${index === 0 && `m-0`} menu
            ${menu.disabled && `menu-disabled`
              }
             ${props.active === menu?.id && `menu-active`
              }`}
            onClick={() => {
              if (!menu?.disabled) {
                props.activeMenu(menu?.id)

              }
            }}
          >
            {menu.title}
          </span>
        ))}
      </div>
      <div className="billing-details-menu-border" />
    </React.Fragment>
  )
}

export default withRouter(MenuBar)
MenuBar.prototype = {
  activeMenu: PropTypes.func,
  menuList: PropTypes.array,
}
